const ServiceGroupsComponent = {

    data() {
        return {
            loading: false,
            departments: [],
        };
    },

    methods: {

        formatNumber(n) {
            const num = Number(n) || 0;
            return String(num).padStart(2, '0');
        },

        async load() {

            this.loading = true;

            try {

                const response = await window.serviceGroupsService.getServiceGroups({
                    page: 1,
                    limit: 200,
                });

                if (response.status !== 200) {
                    console.error('[Departments] bad response', response);
                    return;
                }

                const rows = response.data || [];

                this.departments = rows.map((r, idx) => {
                    return {
                        ...r,
                        number: this.formatNumber(idx + 1),
                    };
                });

            } catch (e) {

                console.error('[Departments] load failed', e);

            } finally {

                this.loading = false;

            }

        },

    },

    mounted() {
        this.load();
    },

};

window.ServiceGroupsComponent = ServiceGroupsComponent;